import { CallTransition } from '../../features/call/call.types';
import { useCallState } from './useCallState';

type UseCallStateActionsProps = {
  setHangUp: () => Promise<void>;
  setRestartInitiated: () => Promise<void>;
};

/**
 * Provides actions that can be called from the app components
 * to trigger a transition in the state based on events happening in the app.
 *
 * @returns An object containing methods to trigger specific state transitions.
 */
export const useCallTransitions = (): UseCallStateActionsProps => {
  const { transition } = useCallState();

  const setHangUp = async (): Promise<void> => {
    await transition(CallTransition.HANG_UP);
  };

  const setRestartInitiated = async (): Promise<void> => {
    await transition(CallTransition.RESTART_INITIATED);
  };

  return {
    setHangUp,
    setRestartInitiated,
  };
};
